// extracted by mini-css-extract-plugin
export default {"Emojify":"bbc_a bhc_g"};